import { render, staticRenderFns } from "./CreateMenuImport.vue?vue&type=template&id=427d5a12&scoped=true"
import script from "./CreateMenuImport.vue?vue&type=script&lang=js"
export * from "./CreateMenuImport.vue?vue&type=script&lang=js"
import style0 from "./CreateMenuImport.vue?vue&type=style&index=0&id=427d5a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d5a12",
  null
  
)

export default component.exports